import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { parents } from 'selectors/tenant'
import { tenants } from 'selectors/entities'

import { sortSev } from 'utils/stuff'



let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , tenants: tenants(state)
	  , parents: parents(state)
	})
)

export class TenantCombobox extends Component{
	render(){
		let { props } = this
		return(
			<Combobox
				icon={
					<img
						src={".." + "/static/img/tenant-green.png"}
						style={{
							width: "20px",
							marginTop: '0px'
					}}/>
				}
				noDelete={props.object.tenantID?true:false}
				link={`/manager/tenant/${props.object.tenantID}/`}
				exist={(props.object && props.object.tenantID || props.object.tenantsIDs && props.object.tenantsIDs[0]) }
				text={(props.object && props.object.tenantID && props.tenants[props.object.tenantID])?props.tenants[props.object.tenantID].tenant || (props.tenants[props.object.tenantID].firstName+" "+props.tenants[props.object.tenantID].lastName)
					:props.object.tenantsIDs && props.object.tenantsIDs[0] && props.tenants[props.object.tenantsIDs[0]]? props.tenants[props.object.tenantsIDs[0]].tenant || props.tenants[props.object.tenantsIDs[0]].firstName+" "+props.tenants[props.object.tenantsIDs[0]].lastName:""}
				hintText={<span>Tenant</span>}
				searchText={
					(props.object.tenantID&&props.tenants[props.object.tenantID])?
						props.tenants[props.object.tenantID].tenant || (props.tenants[props.object.tenantID].firstName+" "+props.tenants[props.object.tenantID].lastName)
						:(props.object.tenantsIDs && props.object.tenantsIDs[0] && props.tenants[props.object.tenantsIDs[0]])? props.tenants[props.object.tenantsIDs[0]].tenant || props.tenants[props.object.tenantsIDs[0]].firstName+" "+props.tenants[props.object.tenantsIDs[0]].lastName:""
				}
				dataSource={
					R.map(tenant => ({
						text: `${tenant.tenant || (tenant.firstName + " " + tenant.lastName)}`
					  , value: (
							<MenuItem
								key={tenant._id}
								primaryText={tenant.tenant || (tenant.firstName + " " + tenant.lastName)}
							/>
						)
					  , id: tenant._id
				  }), sortSev(props.parents, "tenant", "firstName"))
				}
				onChange={(obj)=>{
						obj = obj || {}
						props.STAGE({
							_id: props.objectID
						  , tenantID: obj.id
						})
					}
				}
			/>
		)
	}
}

export default connect(select, dataActions)(TenantCombobox)



// WEBPACK FOOTER //
// ./src/routes/manager/leaseForm/TenantCombobox.js